// 9fbef606107a605d69c0edbcd8029e5d
import { createSelector } from 'reselect';

import {
  APICONFIG_REDUCER_KEY,
  SESSIONCONFIG_REDUCER_KEY,
} from '@tcp/core/src/constants/reducer.constants';

export const getApiConfigState = (state) => {
  return state[APICONFIG_REDUCER_KEY];
};

export const getBrandSwitchedState = createSelector(
  getApiConfigState,

  (apiConfig) => apiConfig.isBrandSwitched || false
);

export const getBrandSwitchedStateApolloStatefulGraqhQl = createSelector(
  getApiConfigState,
  (apiConfig) => apiConfig.isBrandSwitchedApolloStatefulGraphql || false
);

export const getIsLocationEnabled = createSelector(
  getApiConfigState,

  (apiConfig) => apiConfig.locationEnabled || false
);

export const getSiteMaintenanceBannerState = (state) => {
  return (
    state[SESSIONCONFIG_REDUCER_KEY] && state[SESSIONCONFIG_REDUCER_KEY].showSiteMaintenanceBanner
  );
};

export const getPromoSplashLoading = createSelector(
  getApiConfigState,
  (apiConfig) => apiConfig.promoSplashLoading
);

export default {
  getBrandSwitchedState,

  getIsLocationEnabled,
};
